import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import StatusPopup from '@/components/common/statusPopup.vue';
import { useThemeStore } from '@/stores/theme';
import MssageContentView from '@/themes/themeThree/message/messageContentView.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'mssageContentView',
  setup(__props) {

const themeStore = useThemeStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(MssageContentView)
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, { ref: "statusRef" }, null, 512)
  ], 64))
}
}

})